import React, {FC, useState} from 'react';
import {Popover} from 'antd';
import styled from 'styled-components';

const ColorPickerWrapper = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  height: 100%;
  min-height: 32px;
`;

const ColorSquare = styled.div<{color: string}>`
  width: 32px;
  min-height: 32px;
  height: 100%;
  border-radius: 4px;
  background-color: ${props => props.color};
  border: 1px solid #d9d9d9;
  cursor: pointer;
  flex-shrink: 0;
  align-self: stretch;
`;

const ColorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
  padding: 8px;
`;

const ColorOption = styled.div<{color: string; isSelected: boolean}>`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: ${props => props.color};
  border: 2px solid ${props => props.isSelected ? '#1890ff' : '#d9d9d9'};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    border-color: #1890ff;
    transform: scale(1.1);
  }
`;

const PRESET_COLORS = [
  '#FF4D4F', '#FF7A45', '#FFA940', '#FFC53D', '#FFEC3D', '#BAE637', '#73D13D', '#36CFC9',
  '#40A9FF', '#1890FF', '#096DD9', '#0050B3', '#722ED1', '#9254DE', '#B37FEB', '#EFDBFF',
  '#F5222D', '#FA541C', '#FA8C16', '#FADB14', '#A0D911', '#52C41A', '#13C2C2', '#2F54EB',
  '#EB2F96', '#F759AB', '#FF85C0', '#FFADD2', '#D3ADF7', '#B37FEB', '#9254DE', '#722ED1',
];

interface IColorPickerProps {
  value?: string;
  onChange?: (color: string) => void;
  placeholder?: string;
}

export const ColorPicker: FC<IColorPickerProps> = ({
  value = '#1890FF',
  onChange,
  placeholder = 'Выберите цвет',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleColorSelect = (color: string) => {
    onChange?.(color);
    setIsOpen(false);
  };

  const content = (
    <ColorGrid>
      {PRESET_COLORS.map((color, index) => (
        <ColorOption
          key={`${color}-${index}`}
          color={color}
          isSelected={value === color}
          onClick={() => handleColorSelect(color)}
        />
      ))}
    </ColorGrid>
  );

  return (
    <ColorPickerWrapper>
      <Popover
        content={content}
        trigger="click"
        visible={isOpen}
        onVisibleChange={setIsOpen}
        placement="bottomLeft"
      >
        <ColorSquare color={value} />
      </Popover>
    </ColorPickerWrapper>
  );
};

